<template>
    <div>
        <VueApexCharts type="line" :options="chartOptions" :series="series"></VueApexCharts>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import helpers from '../../common/utils/helpers';
export default {
    components : {
        VueApexCharts
    },
    props : {
        dados : {
            required : true
        }
    },
    data : () => ({
        chartOptions : {},
    }),
    computed : {
        series: function() {
            return [
                {
                    name: 'Saldo em conta P&D(com SELIC)',
                    data: this.dados ? this.dados.pontos.map(el => {
                        return el.saldoContaPD.toFixed(2);
                    }) : []
                },
                {
                    name: 'Montante acumulado nos ultimos 2 anos',
                    data: this.dados ? this.dados.pontosMedia2Anos.map(el => {
                        return el.saldoContaPD.toFixed(2);
                    }) : []
                },
            ];
        } 
    },
    watch : {
        dados : {
            handler(){
                this.chartOptions = {
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        textAnchor: 'middle',
                        formatter: function(val) {
                            return helpers.formatarValor(val);
                        }
                    },
                    
                    markers: {
                        size: 7,
                    },
                    xaxis : {
                        categories : this.dados? this.dados.pontos.map(el => {return `${el.mes == 'Marco' ? 'Março' : el.mes}/${el.ano}`; }) : []
                    },
                    yaxis : {
                        labels : {
                            formatter: function(val) {
                                return helpers.formatarValor(val);
                            }
                        },
                    }
                    
                };
            },
            deep : true,
            immediate : true
        }
    },
}
</script>
<style lang="">
    
</style>